module.exports = __webpack_public_path__ + "static/img/sence3.86bfc8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/index1/sence3.jpg
// module id = apgb
// module chunks = 7